import CDP_EVENT_NAMES from 'constants/cdp_events';
import { trackCdp } from 'utilities/tracking';

export const BUNDLE_CDP_EVENT_SOURCES = Object.freeze({
  CART_CARD: 'cart_card',
  COMPARE_PLANS_MODAL: 'compare_plans_modal',
  PAYMENT_STEP: 'payment_step',
});

const presentEntries = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== null && value !== undefined,
    ),
  );

export const buildBundleCdpParams = ({
  trackingData = {},
  offer,
  offeredTier,
  currentTier,
  addedTier,
  removedTier,
  selectedTier,
  previousTier,
  variantToken,
  experimentName,
  experimentVariation,
  source,
}) =>
  presentEntries({
    feature: 'shop',
    order_number: trackingData?.order?.number,
    experiment_name: experimentName || offer?.experiment_name,
    experiment_variation: experimentVariation || offer?.experiment_variation,
    offered_tier: offeredTier || offer?.recommended_tier,
    current_tier: currentTier,
    added_tier: addedTier,
    removed_tier: removedTier,
    previous_tier: previousTier,
    selected_tier: selectedTier,
    variant_token: variantToken,
    source,
  });

export const trackBundleCdpEvent = ({
  eventName,
  trackingData,
  offer,
  offeredTier,
  currentTier,
  addedTier,
  removedTier,
  selectedTier,
  previousTier,
  variantToken,
  experimentName,
  experimentVariation,
  source,
}) => {
  if (!eventName) return;

  trackCdp({
    name: eventName,
    params: buildBundleCdpParams({
      trackingData,
      offer,
      offeredTier,
      currentTier,
      addedTier,
      removedTier,
      selectedTier,
      previousTier,
      variantToken,
      experimentName,
      experimentVariation,
      source,
    }),
  });
};

export const BUNDLE_CDP_EVENT_NAMES = CDP_EVENT_NAMES.SAAS_ON_SHOP;
